/**
 * pr card 내 +N 뱃지 모바일 터치 대응
 */
window.addEventListener('SITE_START', () => {
  const badges = document.querySelectorAll('.--extra-badge');
  if (!badges.length) return;

  init();

  function init() {
    const isHoverDevice = window.matchMedia('(hover: hover)').matches;

    function closeAll() {
      badges.forEach((b) => b.classList.remove('is-active'));
    }

    // popover 위치 검사 (오른쪽 화면 밖이면 --right 추가)
    function adjustPopoverPosition(badge) {
      const popover = badge.querySelector('.__popover');
      if (!popover) return;

      popover.classList.remove('--right');

      const rect = popover.getBoundingClientRect();
      const viewportWidth = window.innerWidth;

      if (rect.right > viewportWidth) {
        popover.classList.add('--right');
      }
    }

    if (isHoverDevice) {
      // PC: hover 시 다른 popover 닫기
      badges.forEach((badge) => {
        badge.addEventListener('mouseenter', () => {
          closeAll();
          badge.classList.add('is-active');
          adjustPopoverPosition(badge);
        });
        badge.addEventListener('mouseleave', () => {
          badge.classList.remove('is-active');
        });
      });
    } else {
      // Mobile: 터치 시 토글 (단, 다른 popover는 모두 닫음)
      badges.forEach((badge) => {
        badge.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();

          const isActive = badge.classList.contains('is-active');
          closeAll(); // 다른 popover 닫기

          if (!isActive) badge.classList.add('is-active');
          adjustPopoverPosition(badge);
        });
      });

      document.addEventListener('click', (e) => {
        if (!e.target.closest('.--extra-badge')) closeAll();
      });
    }
  }

  detectRealResize(() => {
    init();
  });
});
